// RoleManagement.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import AddIcon from '@mui/icons-material/Add';
import {
  IconButton,
  Table,
  Box,
  TableBody,
  TableCell,
  useTheme,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Toolbar,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  InputLabel,
  FormControl,
  Select,
  MenuItem,

  Tooltip,
} from '@mui/material';
import {  Delete } from '@mui/icons-material';
import { callApi } from '../../pages/commonapicall/fetchdata';
import { API_ENDPOINTS } from '../../config/api/apiCall';
import Header from '../../Layout/Header';
import { tokens } from '../../theme/theme';
import { useParams } from "react-router-dom";
// Mock data for demonstration
import CallAlertBar from '../../Layout/Alertbar';
const RoleManagement = () => {
  const { CompanyId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [newRole, setNewRole] = useState({ role_id: 0, role_name: '', description: '', isactive: true });
  const [currentRoleId, setCurrentRoleId] = useState(null);
  const [userRoles, setUserRoles] = useState([]);
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [errorMessages, setErrorMessages] = useState({});




  // Function to reset the form
  const resetForm = () => {
    setIsModalOpen(false);
    setNewRole({ role_name: '', description: '', role_id: 0, isactive: 'true' });
    setCurrentRoleId(null);
  };


  const LoadRoleList = () => {
    let requestBody = {
      CompanyId: 1,
    };

    callApi(API_ENDPOINTS.USER_getUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setUserRoles(data);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('No user roles data found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load user role details');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  useEffect(() => {

    LoadRoleList();
  }, []);

  const navigate = useNavigate();
  const handleBackDashboard = () => {
    //navigate("/UserList");

    const url = `/UserList/${CompanyId}`;
    //const url = `/newordercreate/${IndentId}/${ConfirmationOrderId}`;
    navigate(url);
  }

  // Function to validate user input
  const validateUser = (role) => {
    const errors = {};
    if (!role.role_name) {
      errors.userid = "Role name is required.";
    } else if (!role.description) {
      errors.userid = "Description is invalid.";
    }

    return errors;
  };

  const handleAddUserRole = () => {
    const errors = validateUser(newRole);

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }

    //selectedRoles
    let requestBody = {
      role_id: newRole.role_id,
      role_name: newRole.role_name,
      description: newRole.description,
      isactive: newRole.isactive,
    };

    callApi(API_ENDPOINTS.USER_insertUpdateUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setParentRollSeverityvalue('info');
          setParentRollMessageValue(data);
          setParentRollAlertTitleValue('Info');
          setParentRollMsgOpen(true);
          LoadRoleList();
        }
        else {
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(data);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
        }



        // const updatedUsers = [
        //   ...users,
        //   { ...newUser, id: users.length + 1 }, // Assign a new ID
        // ];
        // setUsers(updatedUsers);
        resetForm();

      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });


  };


  const handleDeleteUserRole = (role) => {

    if (window.confirm(`Are you sure you want to delete this role name (${role.role_name}) ?`)) {
      let requestBody = {
        roleid: role.role_id,
      };

      callApi(API_ENDPOINTS.USER_deleteUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
        .then(data => {
          // Update state with fetched data

          if (data.length > 0) {
            setParentRollSeverityvalue('info');
            setParentRollMessageValue(data);
            setParentRollAlertTitleValue('Info');
            setParentRollMsgOpen(true);
            LoadRoleList();
          }
          else {
            setParentRollSeverityvalue('error');
            setParentRollMessageValue('Unable to delete the user');
            setParentRollAlertTitleValue('Error');
            setParentRollMsgOpen(true);
          }

        })
        .catch(error => {
          // // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
        });
    }




  }


  return (
    <div>
      <Header title={'Role Management'} subtitle="" callback={handleBackDashboard} />
      <Divider />

      <CallAlertBar
        parentRollMsgOpen={parentRollMsgOpen}
        setParentRollMsgOpen={setParentRollMsgOpen}
        parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue}
        parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue}
        parentRollMessageValue={parentRollMessageValue}
        setParentRollMessageValue={setParentRollMessageValue}
      />


      <Box
        m={'5px'}
        gridColumn="span 9"
        gridRow="span 2"
        alignItems="center"
        justifyContent="center"
        // padding={1}
        sx={{
          "& .MuiTable-root": {
            border: "none",
            size: "small",
          },
          "& .MuiTableCell-root": {
            borderBottom: "none",
            border: "1px solid",
            borderColor: `${colors.primary[400]} !important`,
            padding: "2px",  // Further reduced padding
          },
          "& .MuiTableHead-root": {
            borderBottom: "none",
          },
          "& .MuiTableBody-root": {
            overflowY: "auto",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.blueAccent[200]} !important`,
            size: "small",
          },
          "& .MuiTableFooter-root": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
            height: "10px",
          },
          "& .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          // scroll bar
          maxHeight: {
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '80vh', // Large devices (desktops)
            xl: '80vh', // Extra large devices (large desktops)
          },
          overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.primary[400],
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.blueAccent[600],
            borderRadius: '10px',
            '&:hover': {
              background: colors.blueAccent[800],
            },
          },
          '&::-webkit-scrollbar-corner': {
            background: colors.primary[700],
          }
        }}
      >

        <TableContainer>
          <Table size="small">
            <TableHead sx={{ height: 30 }}>
              <TableRow>
                <TableCell>ROLE NAME</TableCell>
                <TableCell>DESCRIPTION</TableCell>
                <TableCell>STATUS</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userRoles.map((role) => (
                <TableRow key={role.role_id}>
                  {/* <TableCell>{role.role_name}</TableCell> */}

                  <TableCell>
                    <span
                      style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => {
                        setNewRole(role);
                        setCurrentRoleId(role.role_id);
                        setIsModalOpen(true);
                      }}
                    >


                      {role.role_name}
                    </span>
                  </TableCell>


                  <TableCell>{role.description}</TableCell>
                  {/* <TableCell>{role.isactive}</TableCell> */}
                  <TableCell >{role.isactive ? 'Active' : 'Inactive'}</TableCell>

                  <TableCell>
                   

                    <Tooltip title="Delete Role">
                      <IconButton
                        color="secondary"
 size='small'
                        onClick={() => {
                          handleDeleteUserRole(role)
                        }}
                      >
                        <Delete fontSize='18px'/>
                      </IconButton>
                    </Tooltip>







                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Box>


      {/* Add/Edit Role Dialog */}
      <Dialog open={isModalOpen} onClose={resetForm}>
        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>{currentRoleId ? 'Edit Role' : 'Add Role'}</DialogTitle>
        <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
          <TextField
            autoFocus
            margin="dense"
            size='small'
            label="Role Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newRole.role_name}
            onChange={(e) => setNewRole({ ...newRole, role_name: e.target.value })}
            required
          />

          <TextField
            autoFocus
            margin="dense"
            size='small'
            label="Description"
            type="text"
            fullWidth
            variant="outlined"
            value={newRole.description}
            onChange={(e) => setNewRole({ ...newRole, description: e.target.value })}
            required
          />

          <FormControl fullWidth margin="dense" size='small'>
            <InputLabel>Status</InputLabel>
            <Select
              value={newRole.isactive}
              onChange={(e) => setNewRole({ ...newRole, isactive: e.target.value })}
            >
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
          <Button onClick={resetForm} size='small' sx={{ textTransform: 'none' }} variant='contained' color="secondary">Cancel</Button>
          <Button onClick={handleAddUserRole} sx={{ textTransform: 'none' }} size='small' variant='contained' color="secondary">
            {currentRoleId ? 'Update Role' : 'Save Role'}
          </Button>
        </DialogActions>
      </Dialog>


      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
          <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

            <Toolbar sx={{ display: 'flex', justifyContent: 'flex-end' }}>


              <Button sx={{ textTransform: 'none' }} size='small' startIcon={<AddIcon />} variant="contained" color="secondary" onClick={() => setIsModalOpen(true)}>
                Add Role
              </Button>



            </Toolbar>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default RoleManagement;
